import type {ConnectJSInitializationPattern} from '../../setupStripeConnect';

// Simple variable to store the last seen initialization pattern for connect.js for analytics purposes
let lastSeenInitializationPattern: ConnectJSInitializationPattern | undefined;

export const getLastSeenConnectJsInitializationPattern = () =>
  lastSeenInitializationPattern;
export const setLastSeenConnectJsInitializationPattern = (
  initializationPattern: ConnectJSInitializationPattern,
) => {
  lastSeenInitializationPattern = initializationPattern;
};
